import { Component, OnInit, Input, HostBinding, Output, EventEmitter } from '@angular/core';

@Component({
  selector: '[tableHeadColumn]',
  templateUrl: './table-head-column.component.html',
  styleUrls: ['./table-head-column.component.css']
})
export class TableHeadColumnComponent implements OnInit {

  @Input() public sortable: boolean;
  @Input() public prop: string = '';
  @Input() public sortProp: string = '';
  @Input() public isSorted: boolean;
  @Input() public sort: string = '';
  @Input() public name: string = '';
  @Output() onSort: EventEmitter<any> = new EventEmitter();
  @HostBinding('class.is-sortable') isSortable: boolean;

  constructor() { }

  ngOnInit() {
    this.isSortable = this.sortable;
  }

  handleSort(prop: string) {
    this.onSort.emit(prop);
  }

}
